exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".src-components-Analysis-___settings__wrapper___kLjmJ{background:#eaeaea;font-family:GothamHTF, sans-serif}.src-components-Analysis-___settings__wrapper___kLjmJ>div{display:flex;align-items:center;max-width:1200px;margin:auto}.src-components-Analysis-___settings__separator___2nG7I{width:100%;height:1px;background:rgba(140,140,140,0.2);margin:0;border:none}\n", ""]);

// Exports
exports.locals = {
	"wrapper": "src-components-Analysis-___settings__wrapper___kLjmJ",
	"separator": "src-components-Analysis-___settings__separator___2nG7I"
};